/**
 * v2's alert: a message the operator must acknowledge (the user, 2026-10-05: "v2 modal (revamp the
 * modal too)"). The queue lives here so core can raise one; `@rista/ui/library/components/AlertDialog`'s
 * `AlertHost` draws it, mounted once by each app's shell. Nothing runs at module load.
 *
 * Behaviour is web v1's warning modal (`helper/commonHelpers.handleWarningModal`, drawn by
 * `homeLayout`): one at a time, and a new one replaces the one showing; closed by OK, the backdrop
 * or Escape. Map: docs/revamps/alert.md.
 */
export interface AlertMessage {
  id: number;
  message: string;
  /** a heading; the host draws "Warning" when none is given */
  title?: string;
}

export interface Alerts {
  show(message: string, title?: string): void;
  dismiss(): void;
  current(): AlertMessage | null;
  subscribe(listener: () => void): () => void;
}

export function createAlerts(): Alerts {
  let current: AlertMessage | null = null;
  let seq = 0;
  const listeners = new Set<() => void>();
  const emit = () => listeners.forEach((l) => l());
  return {
    show(message, title) {
      if (!message) return;
      current = { id: ++seq, message, ...(title ? { title } : {}) };
      emit();
    },
    dismiss() {
      if (!current) return;
      current = null;
      emit();
    },
    current: () => current,
    subscribe(listener) {
      listeners.add(listener);
      return () => void listeners.delete(listener);
    },
  };
}

/** the process's one queue */
export const alerts = createAlerts();
